import { ReactElement } from 'react';
import styles from '@/styles/components/shade-loding.module.less';
import TokenName from '../token/TokenName';
import contractConstants from '@/services/contract.constants';
import { useTranslation } from '@/services';
const MintLoad = (props: SwapLoadData): ReactElement => {
    const { t } = useTranslation('common', 'shade');
    return (
        <div className={styles['mint']}>
            {/* {formatString(t('mint.all'), props.token, props.cToken, props.token)} */}
            {t('mint.y-w-m')}&nbsp;
            <span>
                <TokenName token={contractConstants.Registries.AGDToken} />
            </span>
            &nbsp; {t('mint.amount')} <span>{props.token}</span> <br />
            {t('mint.need')} &nbsp;<span>{props.cToken} </span>
            <span>
                <TokenName token={contractConstants.Registries.PoolPaymentToken} />
            </span>
        </div>
    );
};

export default MintLoad;
